import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Header from '../../shared/Header/header.vue';
import NavSide from '../../shared/NavSide/nav.side.vue';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';
import LPCreateIntro from './LPCreateIntro/l.p.create.intro.vue';
import LPCover from '../../shared/LPCover/l.p.cover.vue';
import LPThanksLetter from '../../shared/LPThanksLetter/l.p.thanks.letter.vue';
import LPSideBySide from '../../shared/LPSideBySide/l.p.sidebyside.vue';
import LPClientInfoForm from '../../shared/LPClientInfoForm/l.p.client.infoform.vue';
import LPPropertyInfoForm from '../../shared/LPPropertyInfoForm/l.p.property.info.form.vue';
import LPComparableSummary from '../../shared/LPComparableSummary/l.p.comparable.summary.vue';
import LPCommunityMarketTrend from '../../shared/LPCommunityMarketTrend/l.p.community.market.trend.vue';
import LPOnTheMarket from '../../shared/LPOnTheMarket/l.p.onthemarket.vue';
import ProgressBarComponent from '../../shared/ProgressBarComponent/progress.bar.component.vue';
import Stacked from '../../shared/Stacked/stacked.vue';
import ASpaceInBetweenAnother from '../../shared/ASpaceInBetweenAnother/a.space.inbetween.another.vue';
// @ts-ignore
import jsPdf from 'jspdf';
// @ts-ignore
import { PDFDocument, ParseSpeeds, range } from 'pdf-lib';
import * as T_T from 'cryface';
import { CommonFunc } from '../../services/DataDelegate/ComonDelegate/common.functions';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';
import { baseUrlEncoder, dataUrlToGray, blobToBase64 } from '../../utils/baseurl.encoder';
import * as moment from 'moment';
import { CreatePageValidate } from './validator';
import { ICmaSaveParam } from '../../models/commons';

@Component({
    components: {
        Header,
        NavSide,
        SpinLoader,
        LPCreateIntro,
        LPCover,
        LPThanksLetter,
        LPSideBySide,
        LPClientInfoForm,
        LPPropertyInfoForm,
        LPComparableSummary,
        LPCommunityMarketTrend,
        LPOnTheMarket,
        Stacked,
        ASpaceInBetweenAnother,
        'rifo-progress': ProgressBarComponent,
    }
})
export default class LPCreatePage extends Vue {
    public title: string = 'LPCreatePage';

    public isLoading = false;

    public isGenerating = false;

    public isGettingCMA = false;

    public modalAdddCMA = false;

    public configs = new CommonConfig();

    public coverImg: any = '';

    public dataUrlPdf: string = '';

    public urlPdfs: any[] = [];

    public generateLastTimeStamp: string = '';

    public reset = true;

    public id = 'new';

    public sendEmail = false;

    public clientInfo: any = {
        name: '',
        phoneSuffix: '+1',
        phone: '',
        salutations: '',
        email: '',
    };

    public propetyInfo: any = {
        propertyType: '',
        bedrooms: '',
        bedroomsPlus: '',
        washrooms: '',
        garages: '',
        picture: '',
    };

    public userInfo = {
        id: 'N/A',
        name: '',
        phone: '',
        wechat: '',
        email: '',
        website: '',
        company: null,
    };

    public cmaResult: any = {
        comparitives: [],
        prediction: {
            lower: 0,
            upper: 0,
        },
    };

    public cmaResultRaw: any = {
        comparitives: [],
        prediction: {
            lower: 0,
            upper: 0,
        },
    };

    public stats = null;

    public community = {
        propertyNew: '',
        community: '',
        city: '',
        sales: 0,
        medPrice: 0,
        avgDom: 0,
    };

    public statsAws = {
        avgPrice: [],
        medPrice: [],
        sales: [],
        doms: [],
        slrs: [],
    };

    public onMarketProperty: any[] = [];

    public searchText: any = {
        name: ''
    };

    @Prop({ default: undefined })
    public data: any;

    public async created() {
        this.$store.commit('selectSection', '11');
        this.isLoading = true;
        if (T_T.simpleDetect(this.$route.params.id)) {
            this.id = this.$route.params.id;
            if (this.id !== 'new') {
                await this.getDetail();
            }
        }
        await this.getTrebPdf();
        this.isLoading = false;
    }

    public reload() {
        this.reset = false;
        this.$nextTick(() => (this.reset = true));
    }

    @Watch('$store.state.lpCreatePage.reload', { immediate: true, deep: true })
    public async onPageReload(val: any, oldVal: any) {
        this.reload();
    }

    public async getDetail() {
        const apiHost = this.configs.apiHost;
        const fetchedList = await AxiosPromise.get(
            `${apiHost}/agent/listing/presentation/detail?id=${this.id}`
        );
        // const fetchedList = await AxiosPromise.get(
        //     `http://192.168.0.40:9528/radar-api/agent/listing/presentation/detail?id=${this.id}`
        // );
        if (fetchedList.errorCode === 200) {
            const paramsFetched: any = JSON.parse(fetchedList.data.param);
            this.clientInfo = paramsFetched.clientInfo;
            this.propetyInfo = paramsFetched.propertyInfo;
            this.community = paramsFetched.community;
            this.statsAws = paramsFetched.statsAws;
            this.sendEmail = paramsFetched.sendEmail;
            this.searchText.name = paramsFetched.subjectSearchText;
            this.searchText.place_id = 'any';
            const cmaRecords = paramsFetched.cmaRecords;
            const cmaApi = this.configs.cmaHost;
            const cmaData = await AxiosPromise.get(`${cmaApi}/cma/record/get/${cmaRecords}`);
            if (cmaData.code === 200) {
                this.cmaResult.comparitives = cmaData.data.map((v: any) => this.comparitiveMapper(v));
            }
        }
    }

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    @Watch('$store.state.auth.userInfo', { immediate: true, deep: true })
    public async onAuthenticated(val: any, oldVal: any) {
        if (T_T.simpleDetect(val)) {
            const storeInfo = await CommonFunc.getStoreInfoByYhId(val.id);
            const newUserInfo = {
                id: val.id,
                name: T_T.simpleDetect(val.partner.displayName) ? val.partner.displayName : '',
                phone: T_T.simpleDetect(val.xPhone) ? val.xPhone : '',
                wechat: T_T.simpleDetect(val.xWechat) ? val.xWechat : '',
                email: T_T.simpleDetect(val.xEmail) ? val.xEmail : '',
                website: T_T.simpleDetect(storeInfo.xdomain) ? `http://${storeInfo.xdomain}` : '',
                title: 'Salesperson',
                company: T_T.simpleDetect(val.partner.company) ? val.partner.company : null,
            };
            this.userInfo = newUserInfo;
        }
    }

    public async handleGenerate() {
        this.onMarketProperty = [];
        const validateRes: string = CreatePageValidate.validator({
            propetyInfo: this.propetyInfo,
            clientInfo: this.clientInfo,
            searchText: this.searchText,
            comparitivesLen: this.cmaResult.comparitives.length
        });
        if (validateRes !== 'validated') {
            alert(validateRes);
        } else {
            this.predict();
            this.isGenerating = true;
            const pictureConvertPromises: Promise<any>[] = [];
            this.coverImg = await dataUrlToGray(this.propetyInfo.picture, 920, 600);
            // test
            const comparitives = this.cmaResult.comparitives;
            comparitives.map((v: any) => {
                if (T_T.simpleDetect(v.picture)) {
                    pictureConvertPromises.push(
                        new Promise(async (resolve, reject) => {
                            v.picture = await baseUrlEncoder(v.picture, 'image/png', 140, 80);
                            resolve(1);
                        })
                    );
                }
                if (T_T.simpleDetect(v.pictures)) {
                    if (comparitives.length > 2) {
                        this.onMarketProperty.push({
                            id: v['MLS#:'],
                            pictures: v['pictures'].filter((pic: any) => { return v['pictures'].indexOf(pic) < 4; }),
                        });
                    } else if (comparitives.length > 1) {
                        this.onMarketProperty.push({
                            id: v['MLS#:'],
                            pictures: v['pictures'].filter((pic: any) => { return v['pictures'].indexOf(pic) < 8; }),
                        });
                    } else if (comparitives.length === 1) {
                        this.onMarketProperty.push({
                            id: v['MLS#:'],
                            pictures: v['pictures'],
                        });
                    }
                }
            });
            for (let j = 0; j < this.onMarketProperty.length; j++) {
                for (let i = 0; i < this.onMarketProperty[j].pictures.length; i++) {
                    pictureConvertPromises.push(
                        new Promise(async (resolve, reject) => {
                            this.onMarketProperty[j].pictures[i] = await baseUrlEncoder(this.onMarketProperty[j].pictures[i], 'image/png', 250, 160);
                            resolve(1);
                        })
                    );
                }
            }
            // console.log(pictureConvertPromises);
            // this.cmaResult.comparitives.map();
            // picture Convert
            const promiseRes = await Promise.all(pictureConvertPromises);
            this.$store.commit('setOnMarketProperty', this.onMarketProperty);
            //
            await this.letsCapture();
            this.isGenerating = false;
            this.generateLastTimeStamp = moment(new Date()).format(this.configs.dateTimeFormat);
            this.onMarketProperty = [];
            this.$store.commit('clearOnMarketProperty');
        }
    }

    public predict() {
        const prices: number[] = [];
        this.cmaResult.comparitives.map((cm: any) => {
            if (T_T.simpleDetect(cm['Price'])) {
                prices.push(Number(cm['Price']));
            } else if (T_T.simpleDetect(cm['List Price'])) {
                prices.push(Number(cm['List Price']));
            }
        });
        if (prices.length > 0) {
            const prediction = T_T.nDis(1.96, prices);
            this.cmaResult.prediction = {
                lower: Math.round(prediction[0]) * 1.05,
                upper: Math.round(prediction[1]) * 1.05,
            };
        }
    }

    public async getCmaReport() {
        this.isGettingCMA = true;
        if (T_T.simpleDetect(this.searchText.name)) {
            const apiHost = this.configs.cmaHost;
            const postBody: any = {
                matchStreetLimit: 20,
                matchTimespanLimit: 20,
                simThreshhold: 0,
            };
            if (T_T.simpleDetect(this.searchText.place_id)) {
                postBody.address = this.searchText.name;
            } else {
                postBody.mlsNumber = this.searchText.name;
            }
            Object.keys(this.propetyInfo).map((key: any) => {
                if (T_T.simpleDetect(this.propetyInfo[key]) && key !== 'picture') {
                    postBody[key] = this.propetyInfo[key];
                }
            });
            let fetched = await AxiosPromise.postUrlEncode(`${apiHost}/cma/report`, postBody);
            if (fetched.status === 200) {
                const keys: string[] = Object.keys(fetched.data.comparitives);
                if (T_T.simpleDetect(keys)) {
                    const comparitives: any[] = [];
                    for (let i = 0; i < keys.length; i++) {
                        fetched.data.comparitives[keys[i]].picture = fetched.data.comparitives[keys[i]].pictures.length > 0 ?
                            fetched.data.comparitives[keys[i]].pictures[0] : '';
                        // fetched.data.comparitives[keys[i]].pictures = [];
                        fetched.data.comparitives[keys[i]].selected = false;
                        comparitives.push(this.comparitiveMapper(fetched.data.comparitives[keys[i]]));
                    }
                    // comparitives = comparitives.filter((v: any) => {
                    //     return comparitives.indexOf(v) < 6;
                    // });
                    this.cmaResultRaw = {
                        prediction: fetched.data.normalPred,
                        comparitives: comparitives,
                    };
                    // stats
                    this.stats = fetched.data.stats;
                }
                // clear memory
                fetched = undefined;
            }
            this.modalAdddCMA = true;
            this.isGettingCMA = false;
            return 1;
        } else {
            alert('\rPlease input mls_number or address of the property. \r \r请输入房源地址或者Mls_Number');
            this.isGettingCMA = false;
            return 0;
        }
    }

    public async letsCapture() {
        //
        const pdfDoc = new jsPdf(
            'p', 'mm', 'letter', true
        );
        const _refs: any = this.$refs;
        const p1: any = _refs.LPCover.$refs.pdf;
        const p2: any = _refs.LPThanksLetter.$refs.pdf;
        const p3: any = _refs.LPComparableSummary.$refs.pdf;
        const p4: any = _refs.LPSideBySide.$refs.pdf;
        const p5: any = _refs.LPCommunityMarketTrend.$refs.pdf;
        const p6: any = _refs.LPOnTheMarket.$refs.pdf;
        // // add option type to get the image version
        // // if not provided the promise will return
        // // the canvas.
        const options = {
            type: 'dataURL',
            onrendered: (canvas: any) => {
            },
            width: p1.clientWidth,
            height: p1.clientHeight,
        };
        const _this: any = this;
        const outputPages = await Promise.all([
            _this.$html2canvas(p1, options),
            _this.$html2canvas(p2, options),
            _this.$html2canvas(p3, options),
            _this.$html2canvas(p4, options),
            _this.$html2canvas(p5, options),
            _this.$html2canvas(p6, options),
        ]);
        pdfDoc.addImage(outputPages[0], 'png', 0, 0, pdfDoc.internal.pageSize.getWidth(), pdfDoc.internal.pageSize.getHeight(), '', 'FAST');
        for (let i = 1; i < outputPages.length; i++) {
            pdfDoc.addPage();
            pdfDoc.addImage(outputPages[i], 'png', 0, 0, pdfDoc.internal.pageSize.getWidth(), pdfDoc.internal.pageSize.getHeight(), '', 'FAST');
        }
        // output as pdf
        // this.dataUrlPdf = pdfDoc.output('datauristring'); // to be used to save pdf on server
        // const dataBlob = pdfDoc.output('blob');
        // const newWindowUrl = URL.createObjectURL(dataBlob);
        // merge Pdf
        const pdfMeged = await PDFDocument.create();
        const trebPdfBytes = await this.getTrebPdf();
        const cmaPdfBytes = pdfDoc.output('arraybuffer');
        const pdfToMergeBytes = [];
        pdfToMergeBytes.push(cmaPdfBytes);
        pdfToMergeBytes.push(trebPdfBytes);
        for (let i = 0; i < pdfToMergeBytes.length; i++) {
            const pdf = await PDFDocument.load(pdfToMergeBytes[i], { parseSpeed: ParseSpeeds.Fastest });
            let pages = [0, 1, 2, 3, 4];
            try {
                pages = range(0, pdf.getPages().length);
            } catch (e) { }
            const copiedPages = await pdfMeged.copyPages(pdf, pages);
            copiedPages.map((page) => {
                pdfMeged.addPage(page);
            });
        }
        const arrayBuffer: Uint8Array = await pdfMeged.save();
        const pdfUrl = URL.createObjectURL(
            new Blob([arrayBuffer], { type: 'application/pdf' }),
        );
        window.open(pdfUrl);
        this.urlPdfs.push(pdfUrl);
        await this.saveCMAOnServer();
        this.dataUrlPdf = pdfUrl;
    }

    public async saveCMAOnServer() {
        const apiHost = this.configs.apiHost;
        const pdfNetwork: Response = await fetch(this.urlPdfs[this.urlPdfs.length - 1]);
        const pdfBlob: Blob = await pdfNetwork.blob();
        let pdfBase64: any = await blobToBase64(pdfBlob);
        pdfBase64 = pdfBase64.replace('data:application/pdf;base64,', '');
        if (!T_T.simpleDetect(this.id) || this.id === 'new') {
            const postBody: ICmaSaveParam = {
                cmaCreateParams:
                {
                    propertyInfo: this.propetyInfo,
                    clientInfo: this.clientInfo,
                    cmaRecords: this.cmaResult.comparitives.map((re: any) => `${re['MLS#:']}`).join(','),
                    subjectSearchText: this.searchText.name,
                    community: this.community,
                    statsAws: this.statsAws,
                    userInfo: this.userInfo,
                },
                yonghuId: this.userInfo.id,
                cmaPDFData: pdfBase64,
                sendEmail: this.sendEmail,
            };
            // alert(JSON.stringify(postBody));
            // console.log(JSON.stringify(postBody));
            try {
                const fetched = await AxiosPromise.postJson(`${apiHost}/agent/listing/presentation/creation`, postBody);
            } catch (e) { }
            // const fetched = await AxiosPromise.postJson(`http://192.168.0.40:9528/radar-api/agent/listing/presentation/creation`, postBody);
            // console.log(fetched);
        } else {
            const postBody: ICmaSaveParam = {
                cmaCreateParams:
                {
                    propertyInfo: this.propetyInfo,
                    clientInfo: this.clientInfo,
                    cmaRecords: this.cmaResult.comparitives.map((re: any) => `${re['MLS#:']}`).join(','),
                    subjectSearchText: this.searchText.name,
                    community: this.community,
                    statsAws: this.statsAws,
                    userInfo: this.userInfo,
                },
                yonghuId: this.userInfo.id,
                cmaPDFData: pdfBase64,
                sendEmail: this.sendEmail,
                id: this.id,
            };
            const fetched = await AxiosPromise.postJson(`${apiHost}/agent/listing/presentation/update`, postBody);
            // const fetched = await AxiosPromise.postJson(`http://192.168.0.40:9528/radar-api/agent/listing/presentation/update`, postBody);
        }
    }

    public async agentLog() {
        const apiHost = this.configs.cimsServHost;
        const activityId = this.globalPudge.functions.getParam('activityId');
        if (T_T.simpleDetect(activityId)) {
            const postBody = {
                activityId: activityId!.value,
                ltype: 1,
            };
            const fetched = await AxiosPromise.postJson(`${apiHost}/agentLog/insert`, postBody);
        }
    }

    public async handlePlaceChage(val: any) {
        this.searchText = val;
    }

    public handleSearchTextChange(val: any) {
        this.searchText = {
            name: val.srcElement.value
        };
    }

    public comparitiveMapper(comparitive: any) {
        const addressCma = T_T.simpleDetect(comparitive.addressCma) ?  comparitive.addressCma : {};
        return {
            'title': 'Comparative Sold',
            'MLS#:': this.detectNull(comparitive.mlsNumber),
            'List Price': this.detectNull(comparitive.price),
            'Price': this.detectNull(comparitive.soldPrice),
            'Address:': T_T.simpleDetect(addressCma)
                ? `${addressCma.streetNumber || ''} ${addressCma.streetName || ''} ${addressCma.suffix || ''}` : 'N/A',
            // 'Municipality:': 'Toronto',
            'Community:': this.detectNull(comparitive.community),
            'Listing Type': this.detectNull(comparitive.listingType),
            'Brokerage': this.detectNull(comparitive.brokerageCma),
            'List Entry Date': moment(this.detectNull(comparitive.listEntryDate)).format(this.configs.dateFormat),
            'Sold Date': moment(this.detectNull(comparitive.soldDate)).format(this.configs.dateFormat),
            'DOM': `${moment(this.detectNull(comparitive.soldDate)).diff(moment(this.detectNull(comparitive.listEntryDate)), 'days')}`,
            'Postal Code:': this.detectNull(addressCma.postalCode),
            'Cross Streets:': this.detectNull(addressCma.crossStreets),
            'PropertyType:': this.detectNull(comparitive.propertyType),
            'Ownership': this.detectNull(comparitive.ownership),
            'Bedrooms': this.detectNull(comparitive.bedrooms),
            'Bedroom plus': this.detectNull(comparitive.bedroomsPlusCma),
            'Washrooms': this.detectNull(comparitive.washrooms),
            'Garages': this.detectNull(comparitive.garages),
            'ApproxAge': this.detectNull(comparitive.approxAge),
            'Basements': T_T.simpleDetect(comparitive.basements) ? comparitive.basements.join(', ') : 'N/A',
            'Storey': this.detectNull(comparitive.storey),
            'BuiltYear': this.detectNull(comparitive.builtYears),
            'Lot Area': this.detectNull(this.decodeArea(comparitive.lotArea)),
            'Usage Area': this.detectNull(this.decodeArea(comparitive.usageArea)),
            'picture': this.detectNull(comparitive.picture),
            'pictures': T_T.simpleDetect(comparitive.pictures) ? comparitive.pictures : [],
            'selected': false,
        };
    }

    public detectNull(prop: any) {
        if (T_T.simpleDetect(prop)) {
            return `${prop}`;
        } else {
            return 'N/A';
        }
    }

    public decodeArea(area: any) {
        if (T_T.simpleDetect(area)) {
            if (T_T.simpleDetect(area.value)) {
                if (T_T.simpleDetect(area.value.x)) {
                    if (T_T.simpleDetect(area.value.unit)) {
                        return `${Math.round(area.value.x * area.value.y)} sq ${area.value.unit || ''}`;
                    } else {
                        return `${Math.round(area.value.x * area.value.y)}`;
                    }
                }
                if (T_T.simpleDetect(area.value.from)) {
                    return `${area.value.from}-${area.value.to} ${area.value.unit || ''}`;
                }
            }
        } else {
            return area;
        }
        return undefined;
    }

    // public selectCM(cm: any) {
    //     this.cmaResult.comparitives.push(cm);
    // }

    public removeCM(index: any) {
        this.cmaResult.comparitives.splice(index, 1);
    }

    public handleModalAdddCMASave() {
        const selected = this.cmaResultRaw.comparitives.filter((cm: any) => {
            return cm.selected;
        });
        if (this.cmaResult.comparitives.length + selected.length < 6) {
            selected.map((cm: any) => {
                if (this.cmaResult.comparitives.map((v: any) => { return v['MLS#:']; }).indexOf(cm['MLS#:']) === -1) {
                    this.cmaResult.comparitives.push(cm);
                }
            });
            this.modalAdddCMA = false;
        } else {
            alert('至多添加五套房源');
        }
    }

    public getByKey(obj: any, key: string) {
        return obj[key];
    }

    public async getTrebPdf(): Promise<ArrayBuffer | null> {
        const apiHost = this.configs.apiHost;
        const year = new Date().getFullYear();
        const month = new Date().getMonth() > 10 ? `${new Date().getMonth()}` : `0${new Date().getMonth()}`;
        const fetched = await AxiosPromise.get(`${apiHost}/commons/cma/report/treb?month=${year}${month}`);
        // console.log(`${apiHost}/commons/cma/report/treb?month=${year}${month}`);
        if (fetched.errorCode === 200) {
            const pdfNetwork: Response = await fetch(fetched.data);
            const arrayBuffer: ArrayBuffer = await pdfNetwork.arrayBuffer();
            return arrayBuffer;
        } else {
            return null;
        }
    }

    public downloadPDFHref(dataURI: string | null) {
        if (dataURI) {
            // convert base64 to raw binary data held in a string
            // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
            const byteString = atob(dataURI.split(',')[1]);

            // separate out the mime component
            const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

            // write the bytes of the string to an ArrayBuffer
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            const convertedUrl = window.URL.createObjectURL(new Blob([ab], { type: mimeString }));
            return convertedUrl;
        }
    }

    public beforeDestroy() {
        this.urlPdfs.map((url: any) => {
            URL.revokeObjectURL(url);
        });
    }

    public interpretSendEmail(v: boolean) {
        if (v) {
            return '是';
        } else {
            return '否';
        }
    }
}
